/* ══════════════════════════════════════════════════════════
   YOURAYOU — Product Image Lightbox JS
   Open/close, arrow navigation, keyboard, counter
   Requires custom-product-shared.js (exposes _yaGalleryGoTo
   and _yaGalleryState on window)
   Load with <script src="..." defer></script>
   ══════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  function init() {
    var lightbox = document.querySelector('.ya-lb');
    var lightboxImg = document.querySelector('.ya-lb__img-wrap img');
    var lightboxCounter = document.querySelector('.ya-lb__counter');
    var mainImageWrap = document.querySelector('.ya-gallery__main');

    if (!lightbox) return;

    function getState() {
      return typeof window._yaGalleryState === 'function' ? window._yaGalleryState() : { currentSlide: 0, totalSlides: 0, mainImg: null, thumbs: [] };
    }

    function goTo(idx) {
      if (typeof window._yaGalleryGoTo === 'function') window._yaGalleryGoTo(idx);
    }

    function updateLightbox() {
      var state = getState();
      var thumb = state.thumbs[state.currentSlide];
      if (lightboxImg) lightboxImg.src = thumb ? thumb.dataset.src : (state.mainImg ? state.mainImg.src : '');
      if (lightboxCounter) lightboxCounter.textContent = (state.currentSlide + 1) + ' / ' + state.totalSlides;
    }

    /* Open lightbox — desktop only */
    if (mainImageWrap) {
      mainImageWrap.addEventListener('click', function(e) {
        if (window.innerWidth <= 768) return;
        /* Skip if clicking nav arrows */
        if (e.target.classList.contains('ya-gallery__nav--prev') || e.target.classList.contains('ya-gallery__nav--next')
            || e.target.closest('.ya-gallery__nav--prev') || e.target.closest('.ya-gallery__nav--next')) return;
        updateLightbox();
        lightbox.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    }

    /* Close button */
    var lightboxClose = document.querySelector('.ya-lb__close');
    if (lightboxClose) {
      lightboxClose.addEventListener('click', function(e) {
        e.stopPropagation();
        lightbox.classList.remove('open');
        document.body.style.overflow = '';
      });
    }

    /* Arrow navigation */
    var lightboxPrev = document.querySelector('.ya-lb__arrow--prev');
    var lightboxNext = document.querySelector('.ya-lb__arrow--next');
    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', function(e) {
        e.stopPropagation();
        var state = getState();
        goTo(state.currentSlide - 1);
        updateLightbox();
      });
    }
    if (lightboxNext) {
      lightboxNext.addEventListener('click', function(e) {
        e.stopPropagation();
        var state = getState();
        goTo(state.currentSlide + 1);
        updateLightbox();
      });
    }

    /* Click outside image to close */
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        lightbox.classList.remove('open');
        document.body.style.overflow = '';
      }
    });

    /* Keyboard navigation */
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') { lightbox.classList.remove('open'); document.body.style.overflow = ''; }
      if (e.key === 'ArrowLeft' && lightboxPrev) lightboxPrev.click();
      if (e.key === 'ArrowRight' && lightboxNext) lightboxNext.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
